import React, { FC } from "react";
import useGlobalModel from "@/model/globalModel";

export interface IYhAuth {
    resCode: string;
}


export const YhAuth: FC<IYhAuth> = (props) => {
    const { user, authRoleIdList, setUser } = useGlobalModel();
    const { resCode, children } = props

    const hasAuth = (resCode: string) => {
        //判断当前用户是否具有资源访问权限
        return authRoleIdList.find((item: string) => item === resCode) ? true : false
    }
    return hasAuth(resCode) ? <>{children}</> : null
}